import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
  className?: string;
  size?: string | number;
  color?: string;
  title?: string;
  style?: React.CSSProperties;
}

export const renderIcon = (IconComponent: IconType, props?: IconProps) => {
  return React.createElement(IconComponent as React.ComponentType<IconProps>, props);
}; 